import { render, staticRenderFns } from "./CalendarEvent.vue?vue&type=template&id=5c75adf4&"
import script from "./CalendarEvent.vue?vue&type=script&lang=js&"
export * from "./CalendarEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardTitle, BBadge, BCardSubTitle, BCol, BRow, BCardBody, BCard} from 'bootstrap-vue'
    installComponents(component, {BCardTitle, BBadge, BCardSubTitle, BCol, BRow, BCardBody, BCard})
    

export default component.exports